<template>
  <div>
    <div class="box">
      <div class="top">
        <div class="title">风险排查</div>
        <div class="desc">精准分析主播，识别潜在风险，降低业务风险</div>
      </div>
      <div class="input" @click="toPaicha">
        <div class="input_l">
          <input type="text" placeholder="请输入主播信息" />
        </div>
        <div>
          <el-button type="primary" class="input_r">
            <img
              src="@/assets/image/home/risk/icon_6.webp"
              alt=""
              style="width: 12px; height: 12px"
            />
            排查</el-button
          >
        </div>
      </div>
      <div class="nav">曝光台检索 ｜ 重复签约检索 ｜ 三要素查询</div>
      <div class="btns">
        <div class="item" v-for="item in list" :key="item.key" @click="btnClick(item)">
          <img class="icon" :src="item.img" alt="" srcset="" />

          <div class="text">{{ item.title }}</div>
        </div>
      </div>
      <weikaifang ref="weikaifangRef" />
    </div>
    <div class="bottom">
      <div class="bottom_item" @click="weikaifang">
        <img src="@/assets/image/icon_004.webp" alt="" />
        <div class="bottom_item_text">权益执行</div>
      </div>
      <div class="bottom_item" @click="toChuZheng">
        <img src="@/assets/image/icon_005.webp" alt="" />
        <div class="bottom_item_text">申请出证</div>
      </div>
    </div>
    <Calculator ref="CalculatorRef"/>
  </div>
</template>

<script>
import userinfo from "@/mixins/userinfo";
import weikaifang from "@/components/weikaifang/index.vue";
import Calculator from "@/components/Calculator/Calculator.vue";
import { mapActions } from "vuex";
export default {
  name: "risk-assessment",
  mixins: [userinfo],
  components: { weikaifang,Calculator },

  data() {
    return {
      list: [
        {
          key: 1,
          title: "常用网址",
          img: require("@/assets/image/home/risk/icon_1.webp"),
        },
        // {
        //   key: 2,
        //   title: "个人所得税计算",
        //   img: require("@/assets/image/home/risk/icon_2.webp"),
        // },
        {
          key: 3,
          title: "电子黄历",
          img: require("@/assets/image/home/risk/icon_3.webp"),
        },
        {
          key: 4,
          title: "起诉费计算",
          img: require("@/assets/image/home/risk/icon_4.webp"),
        },
        // {
        //   key: 5,
        //   title: "星座属性",
        //   img: require("@/assets/image/home/risk/icon_5.png"),
        // },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    ...mapActions("app", ["setServicepopupvisible"]),
    async toPaicha() {
      await this.verifyUserAuth();
      await this.verifyCompanyAuth();
      this.$router.push({ name: "inspiectSearch" });
    },
    weikaifang() {
      this.$refs.weikaifangRef.onshow();
    },
    toChuZheng() {
      this.$router.push({ name: "issueCertificateList" });
    },
    btnClick(item) {
      if (item.key == 3) {
        this.onlink("https://mcn-open.com/huangli");
        return
      }
      if (item.key == 4) {
        this.$refs.CalculatorRef.onShow();
        return
      }
      this.weikaifang();
    },
    onlink(href) {
      window.open(href, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  // height: 458px;
  border-radius: $border-radius;
  background: #fff;

  .top {
    height: 74px;
    padding: 16px;

    .title {
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-weight: 500;
      line-height: 23px;
      font-variation-settings: "opsz" auto;
      color: #262626;
    }

    .desc {
      line-height: 17px;
      font-size: 12px;
      font-variation-settings: "opsz" auto;
      color: #999999;
    }
  }

  .input {
    height: 44px;
    border-radius: 4px;
    opacity: 1;

    /* 自动布局 */
    display: flex;

    background: rgba(245, 245, 245, 0.4);

    box-sizing: border-box;
    border: 1px solid #eeeeee;

    backdrop-filter: blur(4px);
    margin: 0 16px;

    &_l {
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0 12px;

      input {
        background-color: transparent;
        width: 150px;
        font-size: 14px;
      }
    }

    &_r {
      width: 76px;
      height: 44px;
      border-radius: 4px;
      margin-top: -1px;
      /* 自动布局 */
      display: flex;
      align-items: center;
      justify-content: center;

      font-family: "Noto Sans SC";
      font-size: 14px;
      img {
        margin-right: 4px;
      }
    }
  }

  .nav {
    line-height: 44px;

    font-family: "Noto Sans SC";
    font-size: 12px;

    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #999999;
    text-align: center;
  }

  .btns {
    margin-top: 10px;
    padding: 10px 16px 26px;
    display: grid;
    grid-template-columns: repeat(2, 1fr); // 两列等宽
    gap: 16px; // 同时设置行间距和列间距为16px

    .item {
      width: 136px;
      height: 76px;
      border-radius: 6px;

      /* 自动布局 */
      display: flex;

      background: rgba(243, 246, 248, 0.3);

      box-sizing: border-box;
      border: 2px solid #ffffff;

      backdrop-filter: blur(8px);
      box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.06);
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: transform 0.3s;
      &:hover {
        box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
        transform: translateY(-4px);
      }

      .icon {
        width: 30px;
        height: 30px;
      }

      .text {
        margin-top: 4px;
        font-family: "Noto Sans SC";
        font-size: 14px;
        color: #262626;
      }
    }
  }
}
.bottom {
  margin-top: 16px;
  width: 320px;
  height: 60px;
  border-radius: 4px;

  background: rgba(255, 255, 255, 0.5);

  box-sizing: border-box;
  border: 1px solid #ffffff;

  backdrop-filter: blur(10px);
  display: flex;
  &_item {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    gap: 6px;
    img {
      width: 20px;
      height: 20px;
    }
    &_text {
      font-size: 16px;
      color: #262626;
    }
  }
}
</style>
